export default __webpack_public_path__ + "static/ag-got-beats-7c35efff815643865d616aa4f1b5b47c.png";